import { put, select, takeLatest, all } from 'redux-saga/effects';
import { notify } from '@mrlannigan/reapop';
import { sagaError } from 'helpers/handleGenericSagaError';
import apiAuthCall from 'helpers/apiAuthCall';

import { actions, fetchActivitiesSuccess } from './duck';
import { allActivitiesEndpoint } from './selectors';

export function* fetchAllActivities(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(allActivitiesEndpoint, action.payload)
            }
        );
        yield put(fetchActivitiesSuccess(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export default function* activitiesSaga({ api }) {
    yield all([
        takeLatest(actions.FETCH_ALL, fetchAllActivities, api)
    ]);
}



// WEBPACK FOOTER //
// ./src/services/activities/saga.js